// extracted by mini-css-extract-plugin
export default {"content":"OperationAccount_content__R7Ac6"};